import { AreaCount } from 'shared/model/statistic.model';

type Props = {
  item: AreaCount;
};

const TopArea = ({ item }: Props) => {
  return (
    <div className="top-area">
      <div>{item.name}</div>
      <div>{item.count}</div>
    </div>
  );
};

export default TopArea;
